package io.horion.cv.styles

import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import io.horion.cv.utils.Constants.INTER
import org.jetbrains.compose.web.css.px

val DownloadCvButtonStyle = CssStyle {
    base {
        Modifier
            .height(34.px)
            .padding(
                topBottom = 10.px,
                leftRight = 14.px
            )
            .fontSize(14.px)
            .fontFamily(INTER)
            .fontWeight(FontWeight.Normal)
            .styleModifier {
                property("display", "flex")
                property("align-items", "center")
                property("justify-content", "center")
                property("white-space", "nowrap")
            }
    }

    Breakpoint.MD {
        Modifier
            .height(38.px)
            .padding(leftRight = 16.px)
            .fontSize(16.px)
    }

    Breakpoint.LG {
        Modifier
            .height(42.px)
            .padding(leftRight = 20.px)
            .fontSize(18.px)
    }
}